import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import PropTypes from 'prop-types'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'

import NotificationsIcon from '@material-ui/icons/Notifications'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { connect } from 'react-redux'
import { markNotificationsRead} from '../../redux/actions/userActions'

class Notifications extends Component {
    state = {
        anchorEl: null
    }
    handleOpen = (event) => {
        this.setState({ anchorEl: event.target });
    };
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    onMenuOpened = () => {
        let unreadNotificationsIDs = this.props.notifications
            .filter((not) => !not.read)
            .map((not) => not.notificationID);
        this.props.markNotificationsRead(unreadNotificationsIDs);
    };
    render() {
        const notifications = this.props.notifications;
        const anchorEl = this.state.anchorEl;
        dayjs.extend(relativeTime); 
        let notificationIcon;
        if(notifications && notifications.length > 0){
            notifications.filter((not) => not.read === false).length > 0
            ? (
                notificationIcon = (
                    <Badge badgeContent={notifications.filter((not) => not.read === false).length}
                        color='secondary'>
                            <NotificationsIcon fontSize="large" />
                        </Badge>
                )
            ) : (
                notificationIcon = <NotificationsIcon fontSize="large" style={{ color: 'white' }} />
            )
        }   else {
            notificationIcon = <NotificationsIcon fontSize="large" style={{ color: 'white' }}/>
        }
        let notificationsMarkup = notifications &&  notifications.length > 0 ? (
            notifications.map((not) => {
                let verb;
                if(not.type.trim() === 'like'){
                    verb =  'hates'
                 } else if(not.type.trim() === 'comment') {
                     verb =  'rekt you'
                 } else {
                     verb =  'ignored'
                 }
                const time = dayjs(not.createdAt).fromNow();
                const iconColor = not.read ? 'action' : 'red';
                let icon;
                if(not.type.trim() === 'like'){
                   icon =  <FontAwesomeIcon icon="poo" color={iconColor} style={{marginRight: 10 }} />
                } else if(not.type.trim() === 'comment') {
                    icon =  <FontAwesomeIcon icon="head-side-cough" color={iconColor} style={{marginRight: 10 }} />
                } else {
                    icon =  <FontAwesomeIcon icon="blind" color={iconColor} style={{marginRight: 10 }} />
                }

                return (
                    <MenuItem key={not.createdAt} onClick={this.handleClose}>
                        {icon}
                        <Typography component={Link} color='default' variant='body1' to={`/users/${not.recipient}/wreck/${not.wreckID}`}>
                            {not.sender} {verb} your opinion {time}
                        </Typography>
                    </MenuItem>
                )
            })
        ) : (
            <MenuItem onClick={this.handleClose}>
                No one cares about your opinions
            </MenuItem>
        )
        return (
            <Fragment>
                <Tooltip title='Notifications'>
                    <IconButton aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup = 'true'
                        onClick={this.handleOpen}>
                            {notificationIcon}
                        </IconButton>
                </Tooltip>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose} onEntered={this.onMenuOpened}>
                    {notificationsMarkup}
                </Menu>

            </Fragment>
        )
    }
}

Notifications.propTypes = {
    markNotificationsRead: PropTypes.func.isRequired,
    notifications: PropTypes.array.isRequired
}

const mapStateToProps = (state) => ({
    notifications: state.user.notifications
})

export default connect(mapStateToProps, {markNotificationsRead})(Notifications)